function scrollToReviewForm() {
  const starsEl = document.querySelector('.shopify-app-block .spr-starrating');

  starsEl?.addEventListener('click', () => {
    reviewFormEl = document.querySelector('#shopify-product-reviews')

    reviewFormEl?.scrollIntoView({ behavior: "smooth"});
  })
}

document.addEventListener('DOMContentLoaded', () => {
  scrollToReviewForm()
})
